export const AI_PROVIDERS = [
  { id: 'openai', label: 'OpenAI' },
];

export const INTELLIGENCE_LEVELS = [
  { id: 'low', label: 'Low', modelId: 'gpt-6-luna' },
  { id: 'medium', label: 'Medium', modelId: 'gpt-6-sol' },
  { id: 'high', label: 'High', modelId: 'gpt-6-sol-high' },
];

export const DEFAULT_AI_PROVIDER = 'openai';
export const DEFAULT_INTELLIGENCE_LEVEL = 'medium';

const PROVIDER_IDS = new Set(AI_PROVIDERS.map((provider) => provider.id));
const INTELLIGENCE_IDS = new Set(INTELLIGENCE_LEVELS.map((level) => level.id));

export function normalizeAiProvider(value) {
  const provider = String(value || '').trim().toLowerCase();
  return PROVIDER_IDS.has(provider) ? provider : DEFAULT_AI_PROVIDER;
}

export function normalizeIntelligenceLevel(value) {
  const level = String(value || '').trim().toLowerCase();
  return INTELLIGENCE_IDS.has(level) ? level : DEFAULT_INTELLIGENCE_LEVEL;
}

export function modelForIntelligenceLevel(level, provider = DEFAULT_AI_PROVIDER) {
  const normalizedProvider = normalizeAiProvider(provider);
  if (normalizedProvider !== 'openai') return 'gpt-6-sol';
  const match = INTELLIGENCE_LEVELS.find((item) => item.id === normalizeIntelligenceLevel(level));
  return match?.modelId || 'gpt-6-sol';
}

export function intelligenceForModel(modelId) {
  const match = INTELLIGENCE_LEVELS.find((item) => item.modelId === modelId);
  return match?.id || DEFAULT_INTELLIGENCE_LEVEL;
}

export function resolveRecommendedModel({
  aiProvider,
  intelligenceLevel,
  model,
  accountPreferredModel,
  allowModelOverride = true,
} = {}) {
  if (allowModelOverride && model) return model;
  if (!intelligenceLevel && accountPreferredModel) return accountPreferredModel;
  return modelForIntelligenceLevel(intelligenceLevel, aiProvider);
}

